module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.image
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Software Architect specializing in Backend & Blockchain engineering")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2020710e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/HeaderGif.vue
// module id = 42
// module chunks = 0